<template>
    <div id="wrapper">
        <Pitch-Bar index="4"></Pitch-Bar>
        <div id="content-wrapper">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-3">
                        <b-table
                            bordered
                            head-variant="dark"
                            hover
                            responsive                            
                            selectable
                            select-mode="single"                            
                            @row-selected="onRowSelected"
                            table-variant="light"
                            :fields="fields"
                            :items="picklistmenus">
                            <template v-slot:cell(selected)="{ rowSelected }">
                                <template v-if="rowSelected">
                                    <span aria-hidden="true">&check;</span>
                                    <span class="sr-only">Selected</span>
                                </template>
                                <template v-else>
                                    <span aria-hidden="true">&nbsp;</span>
                                    <span class="sr-only">Not selected</span>
                                </template>
                            </template>
                        </b-table>
                    </div>
                    <div class="col-5">
                        <form @submit.prevent="addItem" class="form-inline mb-3">
                            <div class="form-group mr-3" style="width: 86%">
                                <input type="text"
                                       class="form-control"
                                       placeholder="Name"
                                       v-model="added_item_name" style="width: 100%"/>
                            </div>
                            <button class="btn btn-info" type="submit">
                                <i class="fas fa-plus"></i> Add
                            </button>
                        </form>
                        <b-table
                            bordered
                            head-variant="dark"
                            hover
                            small
                            responsive                                                        
                            selectable
                            select-mode="single"
                            table-variant="light"
                            :fields="fieldPicklists"
                            :items="picklists">
                            <template v-slot:cell(pickListValue)="data">
                                <input type="text"
                                       class="form-control"
                                       :value="data.item.pickListValue"
                                       required
                                       @change="updateItem(data, $event)" />
                            </template>
                            <template v-slot:cell(sortOrder)="data">
                                <input type="number"
                                       class="form-control"
                                       :value="data.item.sortOrder"
                                       required
                                       @change="updateItemSort(data, $event)" />
                            </template>
                            <template v-slot:cell(deleted)="data">
                                <b-link class="text-danger" href="#" @click.prevent="deleteItem(data)">
                                    <i class="fas fa-trash"></i>
                                </b-link>                                   
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import PitchBar from "../../components/NhanSu/PitchBar";

export default {
    name: "PicklistMenu",
    components: {
        PitchBar,
    },
    data() {
        return {
            fields: [
                {
                    key: "selected",
                    label: "",
                    thStyle: { width: "50px !important" },
                },
                {
                    key: "pickListName",
                    label: "Category Type",
                },
            ],
            fieldPicklists: [                
                {
                    key: "pickListValue",
                    label: "Category",
                },
                {
                    key: "sortOrder",
                    label: "Sort",
                    thStyle: { width: "100px !important" },
                },
                {
                    key: "deleted",
                    label: "",
                    thStyle: { width: "50px !important" },
                },
            ],

            picklistmenus: [],
            picklists: [],
            selected_type: null,
        }
    },
    methods: {
        initData(picklistmenus) {
            this.picklistmenus = picklistmenus;
        },
        onRowSelected(item) {   
            this.selected_type = item[0].pickListType;         
            axios.get(`/api/picklist/${item[0].pickListType}`).then((res) => this.picklists = res.data);
        },
        addItem() {     
            if (this.selected_type == null) return;       
            if (!(this.added_item_name && this.added_item_name.length)) {
                    this.$toast.error("Please enter category name!", "Error", { timeout: 2000 });
                } else {                    
                    var isItemExist = this.picklists.filter(
                        (picklist) => picklist.pickListValue == this.added_item_name
                    );
                    if (isItemExist.length > 0)
                        this.$toast.error("Category name exists !", "Error", { timeout: 2000 });
                    else {
                        axios
                            .post("/api/Picklist", {
                                PickListType: this.selected_type,
                                PickListValue: this.added_item_name,
                                SortOrder: this.picklists[this.picklists.length - 1].sortOrder + 1,                                
                            })
                            .then((res) => {
                                this.picklists.push(res.data);
                                this.added_item_name = "";
                                this.$toast.success("Create success!", "Success!", {
                                    timeout: 2000,
                                });
                            })
                            .catch((err) => {
                                this.$toast.error(err.response.data, "Error", { timeout: 3000 });
                                this.added_item_name = "";
                            });
                    }
                }
        },
        updateItem(data, event) {
            var new_item_name = event.target.value;
                if (!(new_item_name && new_item_name.length)) {
                    this.$toast.error("Please enter your name !", "Error", { timeout: 3000 });
                    event.target.value = data.item.pickListValue;
                } else {
                    var isItemExist = this.picklists.filter(
                        (item) =>
                            item.pickListValue.toLowerCase() === new_item_name.toLowerCase() &&
                            item.id != data.item.id
                    );
                    if (isItemExist.length > 0) {
                        this.$toast.error("Name already exists !", "Error", { timeout: 2000 });
                        event.target.value = data.item.pickListValue;
                    } else {                        
                        axios
                            .put("/api/Picklist", {
                                id: data.item.id,
                                name: new_item_name,
                            })
                            .then((res) => {
                                this.$toast.success("Update successful !", "Successful", {
                                    timeout: 3000,
                                });
                                this.picklists[data.index].name = new_item_name;
                            })
                            .catch((err) => {
                                this.$toast.error(err.response.data, "Error", { timeout: 3000 });
                                event.target.value = data.item.pickListValue;
                            });
                    }
                }            
        },
        updateItemSort(data, event) {
            var new_item_name = event.target.value;
                if (!(new_item_name && new_item_name.length)) {
                    this.$toast.error("Sort field is empty !", "Error", { timeout: 3000 });
                    event.target.value = data.item.sortOrder;
                } else {
                    var isItemExist = this.picklists.filter(
                        (item) =>
                            item.sortOrder == new_item_name &&
                            item.id != data.item.id
                    );
                    if (isItemExist.length > 0) {
                        this.$toast.error("Sort already exists !", "Error", { timeout: 2000 });
                        event.target.value = data.item.sortOrder;
                    } else {                        
                        axios
                            .put("/api/Picklist/sort", {
                                id: data.item.id,
                                sort: parseInt(new_item_name),
                            })
                            .then((res) => {
                                this.$toast.success("Update successful !", "Successful", {
                                    timeout: 3000,
                                });
                                this.picklists[data.index].name = new_item_name;
                            })
                            .catch((err) => {
                                this.$toast.error(err.response.data, "Error", { timeout: 3000 });
                                event.target.value = data.item.sortOrder;
                            });
                    }
                }            
        },         
        deleteItem(data) {
            this.$toast.question("Do you really want to delete?", "Warning", {
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    displayMode: "once",
                    position: "center",
                    buttons: [
                        [
                            "<button><b>Yes</b></button>",
                            (instance, toast) => {
                                axios
                                    .delete(`api/Picklist/${data.item.id}`)
                                    .then((res) => {
                                        this.picklists.splice(data.index, 1);
                                        this.$toast.success("Delete successfully !", "Successful", {
                                            timeout: 3000,
                                        });
                                    })
                                    .catch((err) => {
                                        this.$toast.error(err.response.data, "Error", {
                                            timeout: 3000,
                                        });
                                    });
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                            true,
                        ],
                        [
                            "<button>Không</button>",
                            function (instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                        ],
                    ],
                });
        }
    },
    beforeRouteEnter(to, from, next) {
        axios
        .all([
            axios.get("/api/PicklistMenu/pitch"),             
            ])
        .then(
            axios.spread((picklistmenu) => {
            next((vm) =>
                vm.initData(picklistmenu.data)
            );
            })
        );
    },
    
}
</script>
